import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getSignatureInfo, signatureConsentForm } from '@/api/module/index';
import vueEsign from "vue-esign";
import html2canvas from "html2canvas";
import PDF from "./PDF.vue";
import { Dialog, Toast } from "vant";
import { decrypt } from "@/assets/utils/cryptoUtil";
export default {
  components: {
    vueEsign: vueEsign,
    PDF: PDF
  },
  props: {
    propsAgreementType: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    propsAgreementType: function propsAgreementType(newVal) {
      console.log("newVal", newVal);
      this.argumentSigned = newVal;
      this.agreementType = this.argumentSigned[this.argumentIndex];
      this.signatureInfo();
    }
  },
  data: function data() {
    return {
      show: false,
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      resultImg: "",
      isCrop: false,
      serialNo: '',
      groupID: '',
      pdfUrl: "",
      isUpload: false,
      signatureDate: '',
      signType: '0',
      items: {},
      //协议类型： 2 妇科同意书（金华中心）  3 乙肝三系同意书（金华中心）
      agreementType: '0',
      //需要返回出去的同意书id 和同意书名称
      agreementSave: [],
      // 待签署的协议书
      argumentSigned: this.propsAgreementType,
      // 下标
      argumentIndex: 0,
      // 显示下标
      argumentNumber: 1,
      argumentDatas: [{
        resultImg: null,
        date: null,
        isSign: false
      }]
    };
  },
  created: function created() {
    if (this.$route.query.serialNo) {
      this.serialNo = this.$route.query.serialNo;
    }

    if (this.$route.query.groupID) {
      this.groupID = this.$route.query.groupID;
    }

    if (this.$route.query.signType) {
      // 0同意书 1拒检书 2 妇科同意书
      this.signType = this.$route.query.signType;
      this.argumentSigned = this.$route.query.signType;
      this.signatureInfo();
    }

    this.agreementType = this.argumentSigned[this.argumentIndex];
  },
  methods: {
    decrypt: decrypt,
    signatureInfo: function signatureInfo() {
      var _this = this;

      var params = {
        groupID: this.groupID,
        signType: this.signType,
        serialNo: this.serialNo
      };
      getSignatureInfo(params).then(function (res) {
        if (res.code == 200 && res.data != null) {
          _this.pdfUrl = res.data.pdfUrl;
          _this.items = res.data;
        } else {
          Dialog.alert({
            title: '提示',
            message: '获取签名信息失败，请联系管理员'
          }).then(function () {
            _this.toTask();
          });
        }
      });
    },
    showPopup: function showPopup() {
      this.show = true;
    },
    handleReset: function handleReset() {
      this.$refs.esign.reset();
    },
    handleGenerate: function handleGenerate() {
      var _this2 = this;

      this.$refs.esign.generate({
        format: "png",
        quality: 0.8
      }).then(function (res) {
        _this2.resultImg = res;
        _this2.show = false;
        var currentTime = new Date();
        var year = currentTime.getFullYear();
        var month = currentTime.getMonth() + 1; // 月份从0开始，因此需要加1

        var day = currentTime.getDate();
        var hours = currentTime.getHours();
        var minutes = currentTime.getMinutes();
        _this2.signatureDate = "".concat(year, "\u5E74").concat(month, "\u6708").concat(day, "\u65E5 ").concat(hours, "\u65F6").concat(minutes, "\u5206");
        console.log("\u5F53\u524D\u65E5\u671F\u662F ".concat(year, "\u5E74").concat(month, "\u6708").concat(day, "\u65E5"));
        _this2.argumentDatas[_this2.argumentIndex] = {
          resultImg: res,
          date: _this2.signatureDate,
          isSign: true
        };
      }).catch(function (err) {
        console.error(err);
        alert("请签名");
      });
      this.handleReset();
    },
    //保存图片
    saveImage: function saveImage() {
      var _this3 = this;

      if (!this.argumentDatas[this.argumentIndex].isSign) {
        Toast.fail("请先签名");
        return;
      } // 当前协议 已签署则进入 跳下一个协议


      if (this.agreementSave[this.argumentIndex]) {
        this.upNext();
        return;
      }

      this.isUpload = true; // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等

      html2canvas(this.$refs.creditQrCodeShare, {
        backgroundColor: '#ffffff',
        //画出来的图片有白色的边框,不要可设置背景为透明色（null）
        useCORS: true,
        //支持图片跨域
        scale: window.devicePixelRatio || 1 //设置放大的倍数

      }).then(function (canvas) {
        // 把生成的base64位图片上传到服务器,生成在线图片地址
        var url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64

        var params = {
          "file": url,
          "serialNo": _this3.serialNo,
          "signType": _this3.signType,
          "groupID": _this3.groupID,
          "agreementType": _this3.agreementType
        };
        signatureConsentForm(params).then(function (res) {
          _this3.isUpload = false;

          if (res.code == 200 && res.data != null) {
            _this3.agreementSave[_this3.argumentIndex] = {
              agreementId: res.data,
              agreementType: _this3.agreementType
            };
            console.log("res.data", _this3.agreementSave.length, _this3.agreementType.length);

            if (_this3.agreementSave.length < _this3.argumentSigned.length) {
              _this3.upNext();
            } else {
              // 已全部签署完毕，siginType有值 跳转值 待办任务；没数据发送邮件
              if (_this3.propsAgreementType.length > 0) {
                _this3.$emit('update:agreementSave', _this3.agreementSave);
              } else {
                Dialog.alert({
                  message: '签署成功！确认后返回列表'
                }).then(function () {
                  _this3.toTask();
                });
              }
            }
          } else {
            if (_this3.propsAgreementType.length > 0) {
              _this3.$emit('update:agreementSave', _this3.agreementSave);
            } else {
              Dialog.alert({
                title: '提示',
                message: '签署失败，请联系管理员'
              }).then(function () {
                _this3.toTask();
              });
            }
          }
        }).catch(function (err) {
          _this3.isUpload = false;
        }); //将图片下载到本地
        // this.imgUrl = url;
        // let a = document.createElement("a"); // 生成一个a元素
        // let event = new MouseEvent("click"); // 创建一个单击事件
        // a.download = name || "截图名称"; // 设置图片名称没有设置则为默认
        // a.href = this.imgUrl; // 将生成的URL设置为a.href属性
        // a.dispatchEvent(event); // 触发a的单击事件
      });
    },
    // 下一份
    upNext: function upNext() {
      if (this.argumentIndex + 1 < this.argumentSigned.length) {
        this.argumentNumber++;
        this.argumentIndex++;
        this.agreementType = this.argumentSigned[this.argumentIndex];

        if (this.argumentDatas[this.argumentIndex] == null) {
          this.argumentDatas[this.argumentIndex] = {
            resultImg: null,
            date: null,
            isSign: false
          };
        }
      }
    },
    // 上一份
    theLastOne: function theLastOne() {
      if (this.argumentIndex + 1 > 1) {
        this.argumentNumber--;
        this.argumentIndex--;
        this.agreementType = this.argumentSigned[this.argumentIndex];
      }
    },
    toTask: function toTask() {
      this.$router.push({
        name: 'letterConsent',
        query: {
          serialNo: this.serialNo
        }
      });
    }
  }
};